import type { QuizQuestion } from '../../../domain';

export type QuizAnswerFeedback = {
  selectedIndex: number;
  correctIndex: number;
  correct: boolean;
};

export type QuizAnswerSlot = {
  top: number;
};

/** Figma answer button vertical positions (161:23939+). */
export const QUIZ_ANSWER_SLOTS: readonly QuizAnswerSlot[] = [
  { top: 996 },
  { top: 1143.707 },
  { top: 1291.414 },
];

export type QuizScreenProps = {
  onGoBack?: () => void;
  onClueClick?: () => void;
};

export type QuizScreenModel = QuizScreenProps & {
  question: QuizQuestion | null;
  feedback: QuizAnswerFeedback | null;
  answerSlots: readonly QuizAnswerSlot[];
  showTicketReward: boolean;
  showDailyLimit: boolean;
  onAnswer?: (index: number) => void;
  onDailyLimitZero?: () => void;
};

export function createQuizScreenModel(
  props: QuizScreenProps & {
    question: QuizQuestion | null;
    feedback: QuizAnswerFeedback | null;
    showTicketReward: boolean;
    showDailyLimit: boolean;
    onAnswer?: (index: number) => void;
    onDailyLimitZero?: () => void;
  },
): QuizScreenModel {
  return {
    question: props.question,
    feedback: props.feedback,
    answerSlots: QUIZ_ANSWER_SLOTS,
    showTicketReward: props.showTicketReward,
    showDailyLimit: props.showDailyLimit,
    onAnswer: props.onAnswer,
    onDailyLimitZero: props.onDailyLimitZero,
    onGoBack: props.onGoBack,
    onClueClick: props.onClueClick,
  };
}

export function getQuizAnswerButtonState(
  index: number,
  feedback: QuizAnswerFeedback | null,
): 'default' | 'correct' | 'incorrect' {
  if (feedback == null) {
    return 'default';
  }
  if (index === feedback.correctIndex) {
    return 'correct';
  }
  if (!feedback.correct && index === feedback.selectedIndex) {
    return 'incorrect';
  }
  return 'default';
}
